var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#afcddc;}.cls-2{fill:#0091eb;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.7,9.44,10.13,5.86,8.36,7.63l3.58,3.57A13.3,13.3,0,0,1,13.7,9.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.5,6.25c.42,0,.84,0,1.25.06V1.25h-2.5V6.31C21.66,6.28,22.08,6.25,22.5,6.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.06,11.2l3.58-3.57L34.87,5.86,31.3,9.44A13.3,13.3,0,0,1,33.06,11.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.19,18.75c0,.41.06.83.06,1.25s0,.84-.06,1.25h5.06v-2.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.5,33.75c-.42,0-.84,0-1.25-.06v5.06h2.5V33.69C23.34,33.72,22.92,33.75,22.5,33.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.75,20c0-.42,0-.84.06-1.25H3.75v2.5H8.81C8.78,20.84,8.75,20.42,8.75,20Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.3,30.56l3.57,3.58,1.77-1.77L33.06,28.8A13.3,13.3,0,0,1,31.3,30.56Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.94,28.8,8.36,32.37l1.77,1.77,3.57-3.58A13.3,13.3,0,0,1,11.94,28.8Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 22.5,
    cy: 20,
    r: 11.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDay);
export default __webpack_public_path__ + "static/media/icon-day.539da2d37bbf9b9151aa4b34d3a182dd.svg";
export { ForwardRef as ReactComponent };